import { render, staticRenderFns } from "./DashboardDepartment.vue?vue&type=template&id=d4d1a7a2&scoped=true"
import script from "./DashboardDepartment.vue?vue&type=script&lang=js"
export * from "./DashboardDepartment.vue?vue&type=script&lang=js"
import style0 from "./DashboardDepartment.vue?vue&type=style&index=0&id=d4d1a7a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d1a7a2",
  null
  
)

export default component.exports